/**
 * 정비소 businessHours(ISeoPlace['businessHours']) 도메인 상수.
 * 운영 데이터의 키는 한글(평일/토요일/연중무휴/휴무일 등)이며, 과거 영문 코드(MON/WEEKDAY/OFF)도 호환한다.
 * 표시 라벨·schema.org 요일 매핑·휴무 판정을 한곳에 모아 FAQ·업체정보·JSON-LD 유틸이 공유한다.
 */

/** businessHours 키 → 화면 표시용 한글 라벨. 한글 키는 매핑 없이 키 자체를 폴백으로 노출한다. */
export const BUSINESS_HOUR_LABELS: Record<string, string> = {
  MON: '월요일',
  TUE: '화요일',
  WED: '수요일',
  THU: '목요일',
  FRI: '금요일',
  SAT: '토요일',
  SUN: '일요일',
  WEEKDAY: '평일',
  HOLIDAY: '공휴일',
  OFF: '휴무일',
}

const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
] as const

const WEEKEND = ['Saturday', 'Sunday'] as const

/**
 * businessHours 키 → schema.org dayOfWeek. 영업시간이 아닌 키(점심시간·휴무일)는 의도적으로 제외한다.
 * 한글 키를 기본으로 하되 과거 영문 코드도 함께 매핑한다.
 */
export const DAY_OF_WEEK_SCHEMA_MAP: Record<string, string | string[]> = {
  평일: [...WEEKDAYS],
  주말: [...WEEKEND],
  연중무휴: [...WEEKDAYS, ...WEEKEND],
  월요일: 'Monday',
  화요일: 'Tuesday',
  수요일: 'Wednesday',
  목요일: 'Thursday',
  금요일: 'Friday',
  토요일: 'Saturday',
  일요일: 'Sunday',
  // 영문 코드 호환
  WEEKDAY: [...WEEKDAYS],
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
  SUN: 'Sunday',
}

/** 영업 요일 값/키에 이 키워드가 있으면 해당 요일은 휴무로 본다. */
export const CLOSED_KEYWORD = '휴무'
